import React, { useState } from 'react';

const matchesSearch = (user, query) => {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const hay = `${user.full_name || ''} ${user.username || ''} ${user.email || ''} ${user.department || ''}`.toLowerCase();
  return hay.includes(q);
};

/**
 * Searchable single-user picker with a Clear button. onChange receives the user id,
 * or '' when cleared.
 */
const UserPickerField = ({
  label,
  users = [],
  value,
  onChange,
  testIdPrefix,
  placeholder = 'Select a user…',
  hint,
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const selected = users.find((u) => u.id === value);
  const filtered = users.filter((u) => matchesSearch(u, search));

  const choose = (id) => {
    onChange(id);
    setOpen(false);
    setSearch('');
  };

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-secondary-700 dark:text-secondary-300 mb-1.5">
        {label}
      </label>
      <div className="flex gap-2">
        <button
          type="button"
          data-testid={`${testIdPrefix}-picker`}
          onClick={() => setOpen((o) => !o)}
          className="input-field flex-1 text-left"
        >
          {selected ? `${selected.full_name || selected.username} (${selected.role})` : placeholder}
        </button>
        {value && (
          <button
            type="button"
            data-testid={`${testIdPrefix}-clear`}
            className="btn-secondary px-3"
            onClick={() => onChange('')}
          >
            Clear
          </button>
        )}
      </div>
      {open && (
        <div className="absolute z-20 mt-1 w-full rounded-lg border border-secondary-200 dark:border-secondary-700 bg-white dark:bg-secondary-800 shadow-lg max-h-56 overflow-auto">
          <div className="p-2 sticky top-0 bg-white dark:bg-secondary-800">
            <input
              data-testid={`${testIdPrefix}-search`}
              type="text"
              className="input-field"
              placeholder="Search users…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoFocus
            />
          </div>
          {filtered.map((u) => (
            <button
              key={u.id}
              type="button"
              data-testid={`${testIdPrefix}-option-${u.id}`}
              className="w-full text-left px-3 py-2 text-sm hover:bg-secondary-50 dark:hover:bg-secondary-700"
              onClick={() => choose(u.id)}
            >
              <span className="font-medium text-secondary-900 dark:text-white">{u.full_name || u.username}</span>
              <span className="text-secondary-500 ml-2 text-xs">
                {u.role}
                {u.department ? ` · ${u.department}` : ''}
              </span>
            </button>
          ))}
          {filtered.length === 0 && <p className="px-3 py-2 text-sm text-secondary-500">No users found</p>}
        </div>
      )}
      {hint && <p className="text-xs text-secondary-500 mt-1">{hint}</p>}
    </div>
  );
};

export default UserPickerField;
